import { Navigate, createFileRoute } from '@tanstack/react-router';

import { CancellationsTab } from '@/components/app/org-settings/tabs';
import { PageShell } from '@/components/app/page-shell';
import { Card, CardContent } from '@/components/ui/card';
import { useActiveOrganization } from '@/features/organization';
import { ROUTES } from '@/lib/route-paths';

export const Route = createFileRoute(
  '/_authed/dashboard/settings/cancellations'
)({
  component: CancellationsSettingsPage,
});

function CancellationsSettingsPage() {
  const { data: organization, isPending } = useActiveOrganization();
  if (isPending) return null;
  if (organization?.bookingDestination !== 'borradh') {
    return <Navigate to={ROUTES.settingsBookings} replace />;
  }

  return (
    <PageShell className="pt-10 pb-8" maxWidth="max-w-[960px]">
      <title>Cancellation and rescheduling | Borrah</title>
      <Card>
        <CardContent className="p-0">
          <CancellationsTab />
        </CardContent>
      </Card>
    </PageShell>
  );
}
